module.exports = __webpack_public_path__ + "img/Huawei-app-gallery.f7edb9b3.png";